<template>
  <div align="center">
    <img
      :src="`${this.data.picture}`"
      style="width: 40px; height: 40px; object-fit: cover; border: 0 none; border-radius: 1000px;"
    >
  </div>
</template>
<script>
export default {
  name: "row-labels",
  props: {
    data: {
      type: Object,
    },
  },
};
</script>